import { useEffect, useState } from "react";
import Nav from "../components/site/Nav";
import Hero from "../components/site/Hero";
import About from "../components/site/About";
import Trilogy from "../components/site/Trilogy";
import Movies from "../components/site/Movies";
import Engineering from "../components/site/Engineering";
import Contact from "../components/site/Contact";
import Footer from "../components/site/Footer";

export default function Landing() {
    const [activeSection, setActiveSection] = useState("hero");

    useEffect(() => {
        const sections = ["hero", "about", "trilogy", "movies", "engineering", "contact"];
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) setActiveSection(entry.target.id);
                });
            },
            { rootMargin: "-40% 0px -50% 0px", threshold: 0 }
        );
        sections.forEach((id) => {
            const el = document.getElementById(id);
            if (el) observer.observe(el);
        });
        return () => observer.disconnect();
    }, []);

    return (
        <div data-testid="landing-page" className="relative">
            <Nav activeSection={activeSection} />
            <Hero />
            <About />
            <Trilogy />
            <Movies />
            <Engineering />
            <Contact />
            <Footer />
        </div>
    );
}
